import { server_endpoint } from "../store";
import axios from "axios";


export const registerAction = formdata => async (dispatch) => {

  // console.log('form data ', formdata)
  try {
    dispatch({
      type: "registerRequest",
    });
    // const userdata = {
    //   name,
    //   email,
    //   password,
    // };

    const data = await axios.post(`${server_endpoint}/user/register`, formdata , {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    });

    // console.log(data);
    dispatch({
      type: "registerSuccess",
      payload: data.data,
    });
  } catch (error) {
    // console.log(error);
    dispatch({
      type: "registerFail",
      payload: error.response.data.message,
    });
  }
};


export const loginAction = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: "loginRequest",
    });
    const userdata = {
      email,
      password,
    };
    // console.log(userdata)
    // console.log(`${server_endpoint}/user/login`, userdata, {});
    // const data = {}
    // const temp = await axios.post('http://localhost:4000/v1/api/user/login' , userdata)

    const data = await axios.post(`${server_endpoint}/user/login`, userdata, {
      headers: {
        "Content-Type": "application/json"
        },
        withCredentials: true
      });

    // console.log(data);
    dispatch({
      type: "loginSuccess",
      payload: data.data,
    });
  } catch (error) {
    // console.log(error);
    dispatch({
      type: "loginFail",
      payload: error.response.data.message,
    });
  }
};

export const loadUserAction = () => async (dispatch) => {
  try {
    dispatch({
      type: "loadUserRequest",
    });

    // console.log(userdata)
    // console.log(`${server_endpoint}/user/profile`);
    // const data = {}
    // const temp = await axios.post('http://localhost:4000/v1/api/user/login' , userdata)

    const data = await axios.get(`${server_endpoint}/user/profile`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

    // console.log(data);
    dispatch({
      type: "loadUserSuccess",
      payload: data.data.user,
    });
  } catch (error) {
    // console.log(error);
    dispatch({
      type: "loadUserFail",
      payload: error?.response?.data?.message,
    });
  }
};


export const logoutAction = () => async (dispatch) => {
  try {
    dispatch({
      type: "logoutRequest",
    });

    const data = await axios.get(`${server_endpoint}/user/logout`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

    // console.log(data)
    dispatch({
      type: "logoutSuccess",
      payload: data.data.message,
    });
  } catch (error) {
    // console.log(error);
    dispatch({
      type: "logoutFail",
      payload: error.response.data.message,
    });
  }
};


export const addToPlaylistAction = (id) => async (dispatch) => {
  try {
    dispatch({
      type: "addToPlaylistRequest",
    });

    const userdata = {
      id
    }

    const data = await axios.post(`${server_endpoint}/user/addtoplaylist`, userdata, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

    // console.log(data);
    dispatch({
      type: "addToPlaylistSuccess",
      payload: data.data.message,
    });
  } catch (error) {
    // console.log(error);
    dispatch({
      type: "addToPlaylistFail",
      payload: error?.response?.data?.message,
    });
  }
};

export const removeFromPlaylistAction = (id) => async (dispatch) => {
  try {
    dispatch({
      type: "removeFromPlaylistRequest",
    });

    const data = await axios.delete(`${server_endpoint}/deletefromplaylist?id=${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

  //   console.log(data);
    dispatch({
      type: "removeFromPlaylistSuccess",
      payload: data.data.message,
    });
  } catch (error) {
    // console.log(error);
    dispatch({
      type: "removeFromPlaylistFail",
      payload: error.response.data.message,
    });
  }
};





export const createSubscriptionAction = () => async (dispatch) => {
  try {
    dispatch({
      type: "createSubscriptionRequest",
    });
 
    const data = await axios.get(`${server_endpoint}/subscribe`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

    // console.log(data) ;
    dispatch({
      type: "createSubscriptionSuccess",
      payload: data.data.subscriptionId,
    });
  } catch (error) {
    // console.log(error);
    dispatch({
      type: "createSubscriptionFail",
      payload: error?.response?.data?.message,
    });
  }
};



export const cancelSubscriptionAction = () => async (dispatch) => {
  try {
    dispatch({
      type: "cancelSubscriptionRequest",
    });
 
    const data = await axios.delete(`${server_endpoint}/cancelsubscription`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

    console.log(data) ;
    dispatch({
      type: "cancelSubscriptionSuccess",
      payload: data.data.message,
    });
  } catch (error) {
    // console.log(error);
    dispatch({
      type: "cancelSubscriptionFail",
      payload: error?.response?.data?.message,
    });
  }
};